import { useEffect } from "react";

const SignupPage = () => {
  return <div>Sign up page code here</div>;
};

export default SignupPage;